






























































































































































import { Component, Vue } from 'vue-property-decorator'
import { getMerchantInfo, setMerchantInfo, MerchantInfo, DeliveryFeeRule } from '@/api/shop'
import ImageUpload from '@/components/ImgUpload/index.vue'

@Component({
  name: 'Shop',
  components: {
    ImageUpload
  }
})
export default class extends Vue {
  // 店铺信息
  private shopInfo: MerchantInfo = {
    name: '',
    logo: '',
    phone: '',
    businessHours: '',
    address: '',
    minOrderAmount: 20,
    // 阶梯式配送费规则：100以内5元，100-200元3元，200以上免配送费
    deliveryFeeRules: [
      { minAmount: 0, maxAmount: 100, fee: 5 },
      { minAmount: 100, maxAmount: 200, fee: 3 },
      { minAmount: 200, maxAmount: null, fee: 0 }
    ]
  }

  // 营业时间（用于时间选择器的双向绑定，转换 "HH:mm-HH:mm" 字符串与数组）
  get businessHours(): string[] | null {
    if (this.shopInfo.businessHours) {
      return this.shopInfo.businessHours.split('-')
    }
    return null
  }

  set businessHours(value: string[] | null) {
    if (value && value.length === 2) {
      this.shopInfo.businessHours = `${value[0]}-${value[1]}`
    } else {
      this.shopInfo.businessHours = ''
    }
  }

  // 表单验证规则
  get rules() {
    return {
      name: [
        { required: true, message: '请输入店铺名称', trigger: 'blur' },
        { min: 2, max: 30, message: '店铺名称长度应在 2-30 个字符之间', trigger: 'blur' }
      ],
      logo: [
        { required: true, message: '请上传店铺Logo', trigger: 'change' }
      ],
      phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      address: [
        { required: true, message: '请输入店铺地址', trigger: 'blur' }
      ]
    }
  }

  $refs!: {
    shopForm: any
  }

  created() {
    this.loadShopInfo()
  }

  // Logo 变更回调
  private handleLogoChange(val: string) {
    this.shopInfo.logo = val
  }

  // 加载商户信息
  private async loadShopInfo() {
    try {
      const res = await getMerchantInfo()
      if (res.data.code === 1 && res.data.data) {
        const data = res.data.data
        this.shopInfo = {
          ...this.shopInfo,
          ...data,
          deliveryFeeRules: data.deliveryFeeRules || []
        }
      }
    } catch (err) {
      console.error('获取商户信息失败：', err)
      this.$message.error('获取商户信息失败：' + (err.message || '未知错误'))
    }
  }

  // 添加配送费规则
  private addDeliveryRule() {
    if (!this.shopInfo.deliveryFeeRules) {
      this.shopInfo.deliveryFeeRules = []
    }
    const rules = this.shopInfo.deliveryFeeRules
    if (rules.length > 0) {
      const lastRule = rules[rules.length - 1]
      // 将原最后一条规则的上限改为下限+100，新规则下限取原上限
      const newMin = lastRule.maxAmount || (lastRule.minAmount + 100)
      lastRule.maxAmount = newMin
      rules.push({
        minAmount: newMin,
        maxAmount: null,
        fee: 0
      })
    } else {
      rules.push({
        minAmount: 0,
        maxAmount: null,
        fee: 5
      })
    }
  }

  // 删除配送费规则
  private removeDeliveryRule(index: number) {
    const rules = this.shopInfo.deliveryFeeRules
    if (!rules || rules.length <= 1) {
      this.$message.warning('至少需要保留一条配送费规则')
      return
    }

    rules.splice(index, 1)

    // 重新调整规则的连续性
    if (index === rules.length) {
      // 如果删除的是最后一条，把现在的最后一条 maxAmount 改为 null
      rules[rules.length - 1].maxAmount = null
    } else if (index > 0) {
      // 如果删除的是中间的，让后一条的 minAmount 等于前一条的 maxAmount
      rules[index].minAmount = rules[index - 1].maxAmount || 0
    } else {
      // 如果删除的是第一条，让新的第一条 minAmount 为 0
      rules[0].minAmount = 0
    }
  }

  // 处理 maxAmount 变更，同步下一条规则的 minAmount
  private handleMaxAmountChange(val: number, index: number) {
    const rules = this.shopInfo.deliveryFeeRules
    if (rules && index < rules.length - 1) {
      rules[index + 1].minAmount = val
    }
  }

  // 保存店铺信息
  private saveShopInfo() {
    this.$refs.shopForm.validate(async (valid: boolean) => {
      if (valid) {
        try {
          const res = await setMerchantInfo({
            id: this.shopInfo.id,
            name: this.shopInfo.name,
            logo: this.shopInfo.logo,
            phone: this.shopInfo.phone,
            businessHours: this.shopInfo.businessHours,
            address: this.shopInfo.address,
          })
          if (res.data.code === 1) {
            this.$message.success('店铺信息保存成功！')
          } else {
            this.$message.error(res.data.msg || '保存失败')
          }
        } catch (err) {
          this.$message.error('保存失败：' + (err.message || '未知错误'))
        }
      }
    })
  }

  // 保存配送设置
  private async saveDeliveryInfo() {
    // 验证阶梯式配送费规则
    const rules = this.shopInfo.deliveryFeeRules
    for (let i = 0; i < rules.length - 1; i++) {
      if (rules[i].maxAmount !== null && rules[i].maxAmount !== rules[i + 1].minAmount) {
        this.$message.error('配送费规则的金额区间不连续，请检查设置')
        return
      }
    }

    try {
      const res = await setMerchantInfo({
        id: this.shopInfo.id,
        minOrderAmount: this.shopInfo.minOrderAmount,
        deliveryFeeRules: this.shopInfo.deliveryFeeRules
      })
      if (res.data.code === 1) {
        this.$message.success('配送设置保存成功！')
      } else {
        this.$message.error(res.data.msg || '保存失败')
      }
    } catch (err) {
      this.$message.error('保存失败：' + (err.message || '未知错误'))
    }
  }
}
